module.exports = __webpack_public_path__ + "static/media/3_1.5a945524.png";